import { render, staticRenderFns } from "./StatList.vue?vue&type=template&id=2787342d&"
import script from "./StatList.vue?vue&type=script&lang=js&"
export * from "./StatList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports